import React, { Children } from 'react';
import { motion } from 'framer-motion';
const painPoints = ['Tu hijo se enoja o explota cuando le quitás el celular', 'Sentís que las pantallas dominan la rutina familiar', 'Discutís todos los días por el tiempo frente a la pantalla', 'Ya probaste poner límites pero no funcionó', 'Tu hijo prefiere el celular antes que jugar o hablar', 'Te sentís culpable por dejarlo tanto tiempo conectado', 'No sabés cómo actuar sin gritar o castigar', 'Notás que duerme mal o está más irritable', 'Querés recuperar la conexión familiar', 'Sabés que algo tiene que cambiar pero no sabés por dónde empezar'];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.4,
      ease: 'easeOut'
    }
  }
};
export function PainPoints() {
  return <section className="w-full bg-warm-white py-16 px-6" data-id="element-60">
      <div className="max-w-2xl mx-auto" data-id="element-61">
        <div className="border-l-4 border-mint pl-6 md:pl-8" data-id="element-62">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5
        }} className="font-playfair text-2xl md:text-3xl font-semibold text-dark-text mb-10 text-center md:text-left" data-id="element-63">
            Este ebook es para vos si…
          </motion.h2>

          <motion.ol variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} className="space-y-4" data-id="element-64">
            {painPoints.map((point, index) => <motion.li key={index} variants={itemVariants} className="font-lato text-base md:text-lg text-dark-text flex items-start gap-3" data-id="element-65">
                <span className="font-semibold text-medium-text min-w-[28px]" data-id="element-66">
                  {index + 1}.
                </span>
                <span data-id="element-67">{point}</span>
              </motion.li>)}
          </motion.ol>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.8
        }} className="font-lato text-medium-text italic mt-10 text-center md:text-left" data-id="element-68">
            No estás solo. A miles de padres les pasa lo mismo.
          </motion.p>
        </div>
      </div>
    </section>;
}